export default __webpack_public_path__ + "static/media/c.17f8b073.png";